import clsx from "clsx";
import MicRecorder from "mic-recorder-to-mp3";
import { useContext, useEffect, useRef, useState, useCallback } from "react";

import { Hidden, Menu, MenuItem } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { Popover, List, ListItem, ListItemButton, ListItemText, ListItemIcon } from "@mui/material";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ClearIcon from "@material-ui/icons/Clear";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import MicIcon from "@material-ui/icons/Mic";
import SendIcon from "@material-ui/icons/Send";
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';

import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import socket from "../../hooks/useSocket";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import RecordingTimer from "./RecordingTimer";
import BatchReopenTicketModal from "../BatchReopenTicketModal";
import EmojiDataPicker from "../EmojiDataPicker";
import CustomSwitch from "../CustomSwitch";
import { Box } from "@mui/material";
import GetUrlTicketPath from "../../helpers/GetUrlTicketPath";
import TicketsQueueSelect from "../TicketsQueueSelect";
import CaptureCamera from "./CaptureCamera";
import SendTemplateModal from "../SendTemplateModal";
// import { useDrafts } from "../../helpers/DraftsNew";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      bottom: 0,
      width: "100%",
    },
  },

  newMessageBox: {
    background: "#eee",
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: "#fff",
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },
  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
  },
  messageInputWaTemplate: {
    "&.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.42)",
    },
    "&.Mui-disabled input::placeholder, &.Mui-disabled textarea::placeholder": {
      color: "rgba(0, 0, 0, 0.42)",
      opacity: 1,
    },
    "&.Mui-disabled input::-webkit-input-placeholder, &.Mui-disabled textarea::-webkit-input-placeholder": {
      color: "rgba(0, 0, 0, 0.42)",
      opacity: 1,
    },
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#eee",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "#f44336",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: "#ffffff",
    padding: 0,
    border: "1px solid #CCC",
    left: 0,
    width: "100%",
  },
  menuWrapper: {
    zIndex: 9999,
  },
  menuItemDivider: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  mobileMenuPaper: {
    [theme.breakpoints.down("sm")]: {
      maxHeight: "60vh",
      overflowY: "auto",
      "-webkit-overflow-scrolling": "touch", // Melhora o scroll no iOS
    }
  },
  sendTemplateButton: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: 4,
    padding: "6px 12px",
    borderRadius: 20,
    border: "1px solid #81c784",
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "inherit",
    lineHeight: 1.2,
    cursor: "pointer",
    whiteSpace: "nowrap",
    outline: "none",
    "&:hover": {
      backgroundColor: "#c8e6c9",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  sendTemplateIcon: {
    fontSize: 20,
    marginRight: 6,
    color: "#2e7d32",
  },
}));

const MessageInput = ({
  ticketStatus,
  ticketId,
  uuid,
  contactId,
  whatsapp,
  ticketQueue,
  byTicketManagement,
  canSendMessageForGroup,
}) => {
  const classes = useStyles();

  const [medias, setMedias] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);
  const [userPreset, setUserPreset] = useState(user);
  const history = useHistory();
  const [batchOpen, setBatchOpen] = useState(false);
  const [annotation, setAnnotation] = useState(
    byTicketManagement == true ? true : false
  );
  const [waBusinessFreeformBlocked, setWaBusinessFreeformBlocked] = useState(false);
  const [waBusinessWindowReason, setWaBusinessWindowReason] = useState("open");
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const ticketInitialState = {
    open: false,
    connectionId: undefined,
    ticketId: undefined,
    userId: undefined,
  };
  const [ticketProps, setTicketProps] = useState(ticketInitialState);
  const [quickAnswerAnchorEl, setQuickAnswerAnchorEl] = useState(null);

  const inputFileRef = useRef(null);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [fileAnchoEl, setFileAnchorEl] = useState(null);
  const isOpen = (fileAnchoEl);

  // const { saveDraft, deleteDraft, showDraft } = useDrafts();

  useEffect(() => {
    // const ticketUUID = GetUrlTicketPath();
    // const filterDraft = showDraft(ticketUUID);

    // // Só carrega rascunho se existir e for para o ticket atual
    // if (filterDraft?.text && ticketUUID === uuid) {
    //   setInputMessage(filterDraft.text);
    // } else {
    //   setInputMessage("");
    // }

    setInputMessage("");
    return () => { };
  }, [uuid]);

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    const getUserSettings = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/users/${user.id}`, {
          signal: abortController.signal,
        });
        if (!isMounted) return;
        setUserPreset(data);
      } catch (err) {
        if (!isMounted || err.name == "AbortError") return;
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    getUserSettings();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  const waBusinessTemplateMode =
    whatsapp?.moduleId == 3 && waBusinessFreeformBlocked && annotation == false;

  const waBusinessPlaceholder = waBusinessWindowReason === "no_client_message"
    ? i18n.t("messagesInput.waTemplateNewConversation")
    : i18n.t("messagesInput.waTemplateExpired");

  const refreshWaBusinessWindow = useCallback(() => {
    if (whatsapp?.moduleId != 3 || annotation) {
      setWaBusinessFreeformBlocked(false);
      setWaBusinessWindowReason("open");
      return;
    }
    api
      .get(`/messages/wabusiness/messaging-window/${ticketId}`)
      .then(({ data }) => {
        setWaBusinessFreeformBlocked(!data?.open);
        setWaBusinessWindowReason(data?.reason || (data?.open ? "open" : "expired"));
      })
      .catch(() => {
        setWaBusinessFreeformBlocked(true);
        setWaBusinessWindowReason("expired");
      });
  }, [ticketId, whatsapp?.moduleId, annotation]);

  useEffect(() => {
    refreshWaBusinessWindow();
  }, [refreshWaBusinessWindow]);

  useEffect(() => {
    if (whatsapp?.moduleId != 3 || !user?.adminId) return;

    const eventName = `appMessage-${user.adminId}`;
    const onAppMessage = (data) => {
      if (data?.message?.fromMe) return;
      const msgTicketId =
        data?.message?.ticketId ??
        data?.message?.Ticket?.id ??
        data?.ticket?.id;
      if (String(msgTicketId) !== String(ticketId)) return;
      refreshWaBusinessWindow();
    };

    const ticketEventName = `ticket-${user.adminId}`;
    const onTicketUpdate = (data) => {
      if (
        data?.action === "update" &&
        String(data?.ticket?.id) === String(ticketId)
      ) {
        refreshWaBusinessWindow();
      }
    };

    socket.on(eventName, onAppMessage);
    socket.on(ticketEventName, onTicketUpdate);
    return () => {
      socket.off(eventName, onAppMessage);
      socket.off(ticketEventName, onTicketUpdate);
    };
  }, [whatsapp?.moduleId, ticketId, user?.adminId, refreshWaBusinessWindow]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setShowEmoji(false);
      setMedias([]);
      setReplyingMessage(null);
    };
  }, [ticketId, setReplyingMessage]);

  const handleChangeInput = (e) => {
    const value = e.target.value;
    setInputMessage(value);
    // handleDrafts(e);

    if (value && value.indexOf("/") === 0) {
      handleLoadQuickAnswer(value);
      setQuickAnswerAnchorEl(e.currentTarget);
      setTypeBar(true);
    } else {
      setTypeBar(false);
      setQuickAnswerAnchorEl(null);
    }

    // if (value === "") {
    //   const ticketUUID = GetUrlTicketPath();
    //   if (ticketUUID && ticketUUID != "undefined") {
    //     deleteDraft(ticketUUID, user.adminId, user.id);
    //   }
    // }
  };

  // const handleDrafts = (e) => {
  //   const ticketUUID = GetUrlTicketPath();
  //   if (!ticketUUID || ticketUUID == "undefined") return;

  //   const text = String(e?.target?.value).trim();
  //   if (text && text != "" && text != "undefined") {
  //     saveDraft(ticketUUID, text, user.adminId, user.id);
  //   }
  // };

  async function sendMesseger(messageData) {
    try {

      if ((messageData.isDrive && messageData.driveUrl) || messageData.mediaInBody) {
        // resgatar informações do ticket e criar pré message
        const response = await api.post(`/messages/media/preMessage`, { ticketId });
        if (response?.data?.messageUUID) messageData.messageUUID = response?.data?.messageUUID;
      }

      await api.post(`/messages/${ticketId}`, messageData);
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  }

  const handleQuickAnswersClick = async (quickAnswer) => {
    setTypeBar(false);

    let { message } = quickAnswer;

    if (message && message.trim() != '' && message != 'undefined') {
      if (user?.signature && user?.name) message = `*${user.name.trim()}:*\n` + message.trim();
      else message = message.trim();
    }

    if (quickAnswer.media) {
      await sendMesseger({
        read: 1,
        fromMe: true,
        mediaInBody: quickAnswer.media,
        body: null,
        cleanMsg: "",
        quotedMsg: null,
        moduleId: whatsapp.moduleId,
        byTicketManagement
      });
    } else if (quickAnswer.isDrive && quickAnswer.driveUrl) {
      await sendMesseger({
        read: 1,
        fromMe: true,
        mediaInBody: null,
        driveUrl: quickAnswer.driveUrl,
        isDrive: quickAnswer.isDrive,
        mediaName: quickAnswer.mediaName,
        body: null,
        cleanMsg: "",
        quotedMsg: null,
        moduleId: whatsapp.moduleId,
        byTicketManagement
      });
    }

    if (message) {
      const msg = {
        read: 1,
        fromMe: true,
        mediaInBody: null,
        body: quickAnswer.message,
        cleanMsg: "",
        quotedMsg: null,
        moduleId: whatsapp.moduleId,
        byTicketManagement
      };

      await sendMesseger(msg)
    }

    setInputMessage("");
  };

  const handleAddEmoji = (emoji) => {
    setInputMessage((prevState) => prevState + emoji);
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 500);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      setMedias([e.clipboardData.files[0]]);
    } else if (e.clipboardData.types.includes("text/plain")) {
      // Verificar se há texto sendo colado
      const pastedText = e.clipboardData.getData("text/plain");
      if (pastedText) {
        // handleDrafts({ target: { value: pastedText } });
      }
    }
  };

  const handleUploadMedia = async (e, idTicket = null) => {
    if (ticketQueue == null && !idTicket) {
      handleOpenBatch();
      return;
    }

    setLoading(true);
    e.preventDefault();

    for await (const media of medias) {
      const formData = new FormData();
      formData.append("fromMe", true);
      formData.append("contactId", contactId);
      formData.append("medias", media);
      formData.append("body", media.name);
      formData.append("caption", inputMessage.trim());
      formData.append("moduleId", whatsapp.moduleId);
      formData.append("annotation", annotation);
      if (replyingMessage)
        formData.append("quotedMsg", JSON.stringify(replyingMessage));

      (async () => {
        try {
          // resgatar informações do ticket e criar pré message
          const response = await api.post(`/messages/media/preMessage`, {
            ticketId,
            annotation,
          });
          if (response?.data?.messageUUID)
            formData.append("messageUUID", response?.data?.messageUUID);

          const { data } = await api.post(
            `/messages/${idTicket != null ? idTicket : ticketId}`,
            formData
          );

          if (data?.chooseQueues == true) {
            setTicketProps({
              open: true,
              ticketId: data.ticket.id,
              connectionId: data.ticket.whatsappId,
            });
          } else {
            if ((data.isNew || idTicket != null) && data?.ticket?.uuid) {
              history.push(`/tickets/${data.ticket.uuid}`);
              document.querySelector("#ticketTabOptions button").click();
            }
          }
        } catch (err) {
          console.error({ err });
          toastError(err);
        }
      })();
    }

    setLoading(false);
    clearInputMessage();
  };

  const handleSaveBatch = async (event, status, props) => {
    try {
      const { data } = await api.post("/tickets", {
        status,
        queueId: props.queueId,
        contactId,
        whatsappId: props.whatsappId,
      });
      // enviar mensagem
      if (medias.length > 0) await handleUploadMedia(event, data.id);
      else await handleSendMessage(data.id);

      handleCloseBatch();
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  };

  const handleOpenBatch = () => {
    setBatchOpen(true);
  };

  const clearInputMessage = useCallback(
    (forceClear = false) => {
      const ticketUUID = GetUrlTicketPath();

      // Só limpa se for o ticket atual ou se for forçado (no envio)
      if (forceClear || ticketUUID === uuid) {
        setInputMessage("");
        setShowEmoji(false);
        setReplyingMessage(null);
        setMedias([]);
        setRecording(false);

        // if (ticketUUID && ticketUUID !== "undefined") {
        //   deleteDraft(ticketUUID, user.adminId, user.id);
        // }

        if (annotation === true && byTicketManagement !== true) {
          handleAnnotation();
        }
      }
    },
    [uuid, annotation, byTicketManagement, user.adminId, user.id]
  );

  const handleCloseBatch = () => {
    setBatchOpen(false);
    // resetar input de texto
    clearInputMessage();
    setLoading(false);
  };

  const handleSendMessage = async (idTicket = null) => {
    if (inputMessage.trim() === "") return;
    if (waBusinessFreeformBlocked && whatsapp?.moduleId == 3 && !annotation) return;
    setLoading(true);

    if (ticketQueue == null && !idTicket) {
      handleOpenBatch();
      return;
    }

    clearInputMessage(true);

    let data = inputMessage.trim();
    if (user?.signature && user?.name) data = `*${user.name.trim()}:*\n` + data;

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: data,
      cleanMsg: inputMessage.trim(),
      quotedMsg: replyingMessage,
      contactId,
      moduleId: whatsapp.moduleId,
      annotation,
      byTicketManagement
    };

    try {
      const { data } = await api.post(
        `/messages/${idTicket != null ? idTicket : ticketId}`,
        message
      );
      if (data?.chooseQueues == true) {
        setTicketProps({
          open: true,
          ticketId: data.ticket.id,
          connectionId: data.ticket.whatsappId,
        });
        clearInputMessage();
      } else {
        if (
          (data.isNew || idTicket != null || ticketId == "00000") &&
          data?.ticket?.uuid
        ) {
          clearInputMessage();
          history.push(`/tickets/${data.ticket.uuid}`);
          document.querySelector("#ticketTabOptions button").click();
        } else {
          clearInputMessage();
        }
      }
    } catch (err) {
      console.error({ err });
      toastError(err);
      setLoading(false);
      return; // Não limpa em caso de erro
    } finally {
      setLoading(false);
      // Foca no input após o envio, mesmo em caso de erro
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);
    }
  };

  const handleLoadQuickAnswer = async (value) => {
    if (value && value.indexOf("/") === 0) {
      try {
        const searchTerm = value.substring(1);

        const { data } = await api.get("/quickAnswers/", {
          params: {
            page: 1,
            rowsPerPage: 100,
            order: "ASC",
            orderBy: "shortcut",
            searchParam: searchTerm
          },
        });

        const sortedQuickAnswers = data.quickAnswers.sort((a, b) => {
          return a.shortcut.localeCompare(b.shortcut);
        });

        setQuickAnswer(sortedQuickAnswers);
        setTypeBar(sortedQuickAnswers.length > 0);
      } catch (err) {
        console.error("Erro ao carregar quick answers:", err);
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  };

  //erro ao gravar audio aqui
  const handleStartRecording = async () => {
    setLoading(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      console.error({ err });
      toastError(err);
      setLoading(false);
    }
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);
      formData.append("moduleId", whatsapp.moduleId);
      if (replyingMessage)
        formData.append("quotedMsg", JSON.stringify(replyingMessage));

      const { data } = await api.post(`/messages/${ticketId}`, formData);
      if (data?.chooseQueues == true) {
        setTicketProps({
          open: true,
          ticketId: data.ticket.id,
          connectionId: data.ticket.whatsappId,
        });
      }
    } catch (err) {
      console.error({ err });
      toastError(err);
    }

    clearInputMessage();
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.Contact?.name}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIconshandleChangeMedias} />
        </IconButton>
      </div>
    );
  };

  const handleAnnotation = async () => {
    setAnnotation(!annotation);
  };

  const getAcceptTypes = (moduleId) => {
    if (moduleId === 2) {
      return [
        "audio/aac",
        "audio/m4a",
        "audio/wav",
        "video/mp4",
        "image/png",
        "image/jpeg",
        "image/gif",
        "video/ogg",
        "video/avi",
        "video/mov",
        "video/webm",
      ].join(", ");
    }
    return undefined;
  };

  // Inicio de métodos para anexos
  const handleAttachmentsClick = (event) => {
    setFileAnchorEl(event.currentTarget);
  };

  const handleAttachmentsClose = () => {
    setFileAnchorEl(null);
  };

  const handleInputFile = (event, type) => {
    if (!event || !type) return;
    event.preventDefault();
    switch (type) {
      case 'image':
        if (inputFileRef?.current) {
          inputFileRef.current.accept = '.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.mp4,.mov,.avi,.mkv,.wmv,.mpg,.mpeg';
          inputFileRef.current.click();
        }
        handleAttachmentsClose();
        break;
      case 'document':
        if (inputFileRef?.current) {
          inputFileRef.current.accept = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.odt,.ods,.odp';
          inputFileRef.current.click();
        }
        handleAttachmentsClose();
        break;
      default:
        break;
    }
  }

  const handleOpenCamera = () => {
    setCameraOpen(true);
    handleAttachmentsClose();
  }

  const handleCloseCamera = () => {
    setCameraOpen(false);
  }

  // Converte qualquer arquivo Base64 → File
  const base64ToFile = (base64, filename) => {
    const [header, data] = base64.split(",");

    if (!header || !data) {
      throw new Error("Base64 inválido");
    }

    // Extrai MIME type
    const mimeMatch = header.match(/data:(.*?);base64/);
    const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";

    // Tenta descobrir extensão pelo MIME
    const ext = mime.split("/")[1] || "";

    // Seta nome automaticamente se não vier extensão
    const finalName = filename.includes(".")
      ? filename
      : `${filename}.${ext}`;

    // Decodifica Base64 → binário
    const binary = atob(data);
    const len = binary.length;
    const buffer = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      buffer[i] = binary.charCodeAt(i);
    }

    return new File([buffer], finalName, { type: mime });
  };

  // 🔄 Usa o File gerado e injeta no input type="file"
  const handleSaveFile = (base64) => {
    const file = base64ToFile(base64, "captura");

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);

    inputFileRef.current.files = dataTransfer.files;

    // Dispara evento de change
    const event = new Event("change", { bubbles: true });
    inputFileRef.current.dispatchEvent(event);
  };
  
  // Fim de métodos para anexos

  const handleTicketClose = () => {
    setTicketProps(ticketInitialState);
  };

  if (medias.length > 0)
    return (
      <>
        <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
          <IconButton
            aria-label="cancel-upload"
            component="span"
            onClick={(e) => setMedias([])}
          >
            <CancelIcon className={classes.sendMessageIcons} />
          </IconButton>

          {loading ? (
            <div>
              <CircularProgress
                className={classes.circleLohandleChangeMediasading}
              />
            </div>
          ) : (
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {Array.isArray(medias) &&
                medias.map((obj) => obj.name).join(", ")}
            </span>
          )}
          <IconButton
            aria-label="send-upload"
            component="span"
            onClick={handleUploadMedia}
            disabled={
              loading ||
              (waBusinessFreeformBlocked && annotation == false) ||
              (whatsapp?.status &&
                String(whatsapp.status).toLowerCase() != "connected")
            }
          >
            <SendIcon className={classes.sendMessageIcons} />
          </IconButton>
        </Paper>
        <TicketsQueueSelect
          open={ticketProps?.open == true ? true : false}
          connectionId={ticketProps?.connectionId}
          ticketId={ticketProps?.ticketId}
          onClose={handleTicketClose}
        />
        <BatchReopenTicketModal
          open={batchOpen}
          loading={loading}
          handleClose={handleCloseBatch}
          onSave={handleSaveBatch}
        />
      </>
    );
  else {
    return (
      <>
        <Paper square elevation={0} className={classes.mainWrapper}>
          {replyingMessage && renderReplyingMessage(replyingMessage)}
          <div className={classes.newMessageBox}>
            <input
              type="file"
              id="upload-file-input"
              name="upload-file-input"
              ref={inputFileRef}
              disabled={
                loading ||
                recording ||
                (whatsapp?.status &&
                  String(whatsapp.status).toLowerCase() !== "connected") ||
                canSendMessageForGroup == false ||
                (waBusinessFreeformBlocked && annotation == false)
              }
              className={classes.uploadInput}
              onChange={handleChangeMedias}
              multiple={true}
              hidden
            />

            <EmojiDataPicker
              onEmojiSelect={(emoji) => handleAddEmoji(emoji)}
              disabled={
                loading ||
                recording ||
                (whatsapp?.status &&
                  String(whatsapp.status).toLowerCase() != "connected") ||
                canSendMessageForGroup == false ||
                (waBusinessFreeformBlocked && annotation == false)
              }
            />

            <IconButton
              aria-label="upload"
              component="span"
              disabled={
                loading ||
                recording ||
                (whatsapp?.status &&
                  String(whatsapp.status).toLowerCase() != "connected") ||
                canSendMessageForGroup == false ||
                (waBusinessFreeformBlocked && annotation == false)
              }
              onClick={handleAttachmentsClick}
            >
              <AttachFileIcon className={classes.sendMessageIcons} />
            </IconButton>


            <Popover
              open={isOpen}
              anchorEl={fileAnchoEl}
              onClose={handleAttachmentsClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
            >
              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={(event) => handleInputFile(event, 'image')}
                  >
                    <ListItemIcon sx={{ minWidth: '30px', color: '#0d47a1' }}>
                      <PhotoLibraryOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={i18n.t('messagesInput.photosAndVideos')} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => handleOpenCamera()}
                  >
                    <ListItemIcon sx={{ minWidth: '30px', color: '#880e4f' }}>
                      <CameraAltOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={i18n.t('messagesInput.camera')} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={(event) => handleInputFile(event, 'document')}
                  >
                    <ListItemIcon sx={{ minWidth: '30px', color: '#1b5e20' }}>
                      <DescriptionOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={i18n.t('messagesInput.documents')} />
                  </ListItemButton>
                </ListItem>

                <Hidden only={["md", "lg", "xl"]}>
                  <ListItem disablePadding>
                    <ListItemButton
                       onClick={handleAnnotation}
                    >
                      <ListItemIcon sx={{ minWidth: '30px', color: '#0d47a1' }}>
                        <CustomSwitch
                          value={annotation}
                          disabled={
                            byTicketManagement == true ||
                              canSendMessageForGroup == false
                              ? true
                              : false
                          }
                        />
                      </ListItemIcon>
                      <ListItemText primary={i18n.t("messagesInput.annotation")} />
                    </ListItemButton>
                  </ListItem>
                </Hidden>
              </List>
            </Popover>

            <Hidden only={["sm", "xs"]}>
              <Box style={{ width: "100px" }}>
                <CustomSwitch
                  rightText={i18n.t("messagesInput.annotation")}
                  value={annotation}
                  disabled={
                    byTicketManagement == true ||
                      canSendMessageForGroup == false
                      ? true
                      : false
                  }
                  onClick={handleAnnotation}
                />
              </Box>
            </Hidden>
            <div className={classes.messageInputWrapper}>
              <InputBase
                inputRef={inputRef}
                className={clsx(classes.messageInput, waBusinessTemplateMode && classes.messageInputWaTemplate)}
                placeholder={
                  waBusinessTemplateMode
                    ? waBusinessPlaceholder
                    : whatsapp?.status &&
                      String(whatsapp.status).toLowerCase() != "connected" &&
                      annotation == false
                      ? i18n.t("messagesInput.placeholderConnection")
                      : i18n.t("messagesInput.placeholderOpen")
                }
                multiline
                maxRows={5}
                value={inputMessage}
                onChange={handleChangeInput}
                disabled={
                  recording ||
                  loading ||
                  (waBusinessFreeformBlocked && annotation == false) ||
                  (whatsapp?.status &&
                    String(whatsapp.status).toLowerCase() != "connected" &&
                    annotation == false) ||
                  canSendMessageForGroup == false
                }
                onPaste={handleInputPaste}
                onKeyPress={(e) => {
                  if (loading || e.shiftKey) return;
                  else if (e.key === "Enter") {
                    handleSendMessage();
                  }
                }}
                onBlur={(e) => {
                  // Impede que o input perca o foco quando o menu está aberto
                  if (typeBar) {
                    e.preventDefault();
                    inputRef.current.focus();
                  }
                }}
              />
              {typeBar && quickAnswers.length > 0 && (
                <Menu
                  open={typeBar}
                  onClose={() => {
                    setTypeBar(false);
                    inputRef.current.focus();
                  }}
                  anchorEl={quickAnswerAnchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    className: classes.mobileMenuPaper,
                    style: {
                      width: inputRef.current?.clientWidth,
                      maxHeight: 300,
                      overflow: "auto",
                      boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2)",
                    },
                  }}
                  MenuListProps={{
                    style: {
                      padding: 0,
                    },
                  }}
                  disableAutoFocus={true}
                  disableEnforceFocus={true}
                  disableRestoreFocus={true}
                >
                  {quickAnswers.map((value, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        handleQuickAnswersClick(value);
                        setTypeBar(false);
                        setTimeout(() => inputRef.current.focus(), 100);
                      }}
                      className={classes.menuItemDivider}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "8px 16px",
                        minHeight: "auto",
                      }}
                    >
                      {value.isDrive && (
                        <AttachFileIcon
                          fontSize="small"
                          style={{
                            verticalAlign: "middle",
                            marginRight: "8px",
                            fontSize: "16px",
                          }}
                        />
                      )}
                      {value.shortcut}
                    </MenuItem>
                  ))}
                </Menu>
              )}
            </div>
            {waBusinessTemplateMode ? (
              <button
                type="button"
                className={classes.sendTemplateButton}
                onClick={() => setTemplateModalOpen(true)}
                disabled={loading}
              >
                <ChatBubbleOutlineIcon className={classes.sendTemplateIcon} />
                {i18n.t("messagesInput.sendTemplate")}
              </button>
            ) : inputMessage ? (
              <IconButton
                aria-label="sendMessage"
                component="span"
                onClick={() => handleSendMessage()}
                disabled={
                  loading ||
                  (waBusinessFreeformBlocked && annotation == false) ||
                  (whatsapp?.status &&
                    String(whatsapp.status).toLowerCase() != "connected") ||
                  canSendMessageForGroup == false
                }
              >
                <SendIcon className={classes.sendMessageIcons} />
              </IconButton>
            ) : recording ? (
              <div className={classes.recorderWrapper}>
                <IconButton
                  aria-label="cancelRecording"
                  component="span"
                  fontSize="large"
                  disabled={
                    loading ||
                    (waBusinessFreeformBlocked && annotation == false) ||
                    (whatsapp?.status &&
                      String(whatsapp.status).toLowerCase() != "connected") ||
                    canSendMessageForGroup == false
                  }
                  onClick={handleCancelAudio}
                >
                  <HighlightOffIcon className={classes.cancelAudioIcon} />
                </IconButton>
                {loading ? (
                  <div>
                    <CircularProgress className={classes.audioLoading} />
                  </div>
                ) : (
                  <RecordingTimer />
                )}

                <IconButton
                  aria-label="sendRecordedAudio"
                  component="span"
                  onClick={handleUploadAudio}
                  disabled={
                    loading ||
                    (waBusinessFreeformBlocked && annotation == false) ||
                    (whatsapp?.status &&
                      String(whatsapp.status).toLowerCase() != "connected") ||
                    canSendMessageForGroup == false
                  }
                >
                  <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
                </IconButton>
              </div>
            ) : (
              <IconButton
                aria-label="showRecorder"
                component="span"
                disabled={
                  loading ||
                  (waBusinessFreeformBlocked && annotation == false) ||
                  (whatsapp?.status &&
                    String(whatsapp.status).toLowerCase() != "connected") ||
                  canSendMessageForGroup == false
                }
                onClick={handleStartRecording}
              >
                <MicIcon className={classes.sendMessageIcons} />
              </IconButton>
            )}
          </div>
        </Paper>
        <TicketsQueueSelect
          open={ticketProps?.open == true ? true : false}
          connectionId={ticketProps?.connectionId}
          ticketId={ticketProps?.ticketId}
          onClose={handleTicketClose}
        />
        <BatchReopenTicketModal
          open={batchOpen}
          loading={loading}
          handleClose={handleCloseBatch}
          onSave={handleSaveBatch}
        />
        <CaptureCamera
          open={cameraOpen}
          onClose={() => handleCloseCamera()}
          onSave={handleSaveFile}
        />
        {templateModalOpen && (
          <SendTemplateModal
            open={templateModalOpen}
            onClose={() => setTemplateModalOpen(false)}
            ticketId={ticketId}
            onSent={() => {
              refreshWaBusinessWindow();
              setTemplateModalOpen(false);
            }}
          />
        )}
      </>
    );
  }
};

export default MessageInput;